export default __webpack_public_path__ + "static/media/illustration-sm.31fcc661.svg";